import UberEats from '../../../images/UberEats.png';

const UberEatsIcon = () => (
  <div className="order-res-links-icon">
    <img src={UberEats} alt="Uber Eats" />
  </div>
);

export default UberEatsIcon;
